<template>
  <Teleport :to="'body'">
    <Modal
      ref="snapshotsModal"
      :title=" mode === 'add' ? 'Add Snapshots' : 'Restore Snapshot'"
      :width="'800px'"
    >
      <!-- <template #modal-header /> -->
      <template #modal-main>
        <div class="settings container scrollbar">
          <template v-if="mode==='add'">
            <div class="row mt-2">
              <div class="col-6 settings__control-group">
                <label class="required">Project</label>
                <select
                  id="project-select"
                  v-model="project"
                  class="select"
                  required
                  @change="selectedProjectChange(project)"
                >
                  <option :key="'project-select-null'" disabled :value="null">
                    Select a Project
                  </option>
                  <option v-for="option in projects" :key="`project-select-${option.id}`" :value="option">
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-6 settings__control-group">
                <label class="required">Dataset</label>
                <select
                  id="source-DS-select"
                  v-model="dataset"
                  class="select"
                  required
                >
                  <option :key="'source-select-null'" disabled :value="null">Select a Dataset</option>
                  <option v-for="option in datasets" :key="`select-${option.id}`" :value="option">
                    {{ option.name }}
                  </option>
                </select>
              </div>
              <div v-if="dataset && dataset.annotation_sets" class="col settings__control-group align-items-start">
                <label>Annotation Set</label>
                <select
                  id="source-DS-select"
                  v-model="annotationSet"
                  class="select"
                  required
                >
                  <option :key="'source-select-null'" :value="null">Select annotation set</option>
                  <option v-for="option in dataset.annotation_sets" :key="`select-${option.id}`" :value="option">
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 settings__control-group">
                <label class="required">Name</label>
                <textarea
                  v-model="new_snapshot"
                  placeholder="Name for the snapshot"
                  class="select description-body"
                  rows="10"
                  cols="50"
                />
              </div>
            </div>
          </template>
          <template v-else>
            <div class="row mt-2">
              <div class="col-12 settings__control-group">
                <label class="label">Snapshot Description</label>
                <label class="snapshot-desc">{{ snapshot ? snapshot.description : '' }}</label>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-6 settings__control-group">
                <label class="required">Project</label>
                <select
                  id="project-select"
                  v-model="project"
                  class="select"
                  required
                  @change="selectedProjectChange(project)"
                >
                  <option :key="'project-select-null'" disabled :value="null">
                    Select a Project
                  </option>
                  <option v-for="option in projects" :key="`project-select-${option.id}`" :value="option">
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row mt-1">
              <v-checkbox
                v-model="mcapTopics"
                color="#250e81"
                :hide-details="true"
                :density="'compact'"
              >
                <template #label>
                  <span class="checkbox-label">Use MCAP Selected Topics</span>
                  <SVGIcon
                    v-tooltip="`Only selected topics will be used for mcap file publishing and will be shown on the result dataset.
                     An mcap file is required in the snapshot for this functionality to take effect. Else, all topics are stored.
                     Camera topics (JPEG and H264) are always enabled to ensure meaningful data.`"
                    :width="'20px'"
                    :height="'20px'"
                    :iconName="'info'"
                    class="help-icon"
                  />
                </template>
              </v-checkbox>
            </div>
            <div v-if="mcapTopics" class="row ml-3 mt-1">
              <div class="col-12 topics-grid">
                <v-checkbox
                  v-for="(topic,i) in topics"
                  :key="i"
                  v-model="selectedTopics"
                  color="#250e81"
                  :hide-details="true"
                  :density="'compact'"
                  :value="topic.value"
                  :disabled="topic.value === '/camera/jpeg' || topic.value === '/camera/h264'"
                >
                  <template #label>
                    <span class="checkbox-label">{{ topic.display }}</span>
                  </template>
                </v-checkbox>
              </div>
            </div>
            <div class="row mt-3">
              <v-checkbox
                v-model="useFPS"
                color="#250e81"
                :hide-details="true"
                :density="'compact'"
              >
                <template #label>
                  <span class="checkbox-label">Use MCAP Frame Rate</span>
                  <SVGIcon
                    v-tooltip="`Adjust the frame rate (FPS) to process mcap files in the snapshot at. This will affect Depth Generation and AI Ground Truth Generation.`"
                    :width="'20px'"
                    :height="'20px'"
                    :iconName="'info'"
                    class="help-icon"
                  />
                </template>
              </v-checkbox>
            </div>
            <div v-if="useFPS" class="row ml-3 mt-1">
              <div class="col-6 settings__control-group">
                <label>FPS</label>
                <input
                  v-model="fps"
                  class="input"
                  type="number"
                  min="1"
                >
              </div>
            </div>
            <div class="row mt-3">
              <v-checkbox
                v-model="depthGen"
                color="#250e81"
                :hide-details="true"
                :density="'compact'"
              >
                <template #label>
                  <span class="checkbox-label">Depth Generation</span>
                  <SVGIcon
                    v-tooltip="`Generate Depth Maps for frames in snapshot.`"
                    :width="'20px'"
                    :height="'20px'"
                    :iconName="'info'"
                    class="help-icon"
                  />
                </template>
              </v-checkbox>
            </div>
            <div class="row mt-3">
              <v-checkbox
                v-model="agtgPipeline"
                color="#250e81"
                :hide-details="true"
                :density="'compact'"
              >
                <template #label>
                  <span class="checkbox-label">AI Ground Truth Generation</span>
                  <SVGIcon
                    v-tooltip="`Generate 2D Bounding Boxes and Segmentation Masks for frames in snapshot. 3D Bounding Boxes are also generated if LiDAR or Radar files are available.`"
                    :width="'20px'"
                    :height="'20px'"
                    :iconName="'info'"
                    class="help-icon"
                  />
                </template>
              </v-checkbox>
            </div>
            <div class="row mt-3">
              <div class="col-12 settings__control-group">
                <label class="label">Dataset name (Optional)</label>
                <input
                  v-model="createNewName"
                  class="select"
                  type="text"
                >
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 settings__control-group">
                <label>Dataset description (Optional)</label>
                <textarea
                  v-model="createNewDescription"
                  rows="2"
                  cols="50"
                />
              </div>
            </div>
            <div v-if="message" class="row mt-3">
              <div class="col-12 settings__control-group">
                <div class="result error">
                  <span>{{ message }}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
      <template #modal-footer>
        <div class="footer">
          <button
            v-if="mode === 'add'"
            class="button button-sm"
            :class="{'button-spinner': isStartingSnapshot}"
            :disabled="isStartingSnapshot || (!new_snapshot || (new_snapshot && new_snapshot === '') || !dataset)"
            @click="addSnapshot"
          >
            Add Snapshot
          </button>
          <button
            v-else
            class="button button-sm"
            :class="{'button-spinner': isStartingSnapshot}"
            :disabled="isStartingSnapshot || !project"
            @click="restoreSnapshot"
          >
            Restore Snapshot
          </button>
        </div>
      </template>
    </Modal>
  </Teleport>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import Modal from '@/components/Modal.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import InlineLoader from '@/components/InlineLoader.vue';
import useTaskModal from '@/composables/useTaskModal.js';

const $toast = useToast();

export default {
  name: 'SnapshotAddModal',
  components: {
    Modal,
    SVGIcon,
  },
  props: {
    mode: {
      type: String,
      default: 'add',
    },
    snapshot: {
      type: Object,
      default: () => {},
    },
    projects: {
      type: Array,
      default: () => [],
    },
    inputProject: {
      type: Object,
      default: () => {},
    },
    inputDataset: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['restore-snapshot', 'add-snapshot'],
  setup() {
    const {
      pauseGetTasks,
      resumeGetTasks,
      isGettingTasks,
      getTasks,
    } = useTaskModal();

    return {
      pauseGetTasks,
      resumeGetTasks,
      isGettingTasks,
      getTasks,
    };
  },
  data() {
    return {
      dataConnect: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      project: null,
      dataset: null,
      datasets: null,
      annotationSet: null,
      new_snapshot: '',
      createNewName: '',
      createNewDescription: '',
      message: '',
      depthGen: false,
      agtgPipeline: false,
      mcapTopics: false,
      selectedTopics: ['/camera/jpeg', '/camera/h264', '/model/boxes2d', '/model/mask', '/radar/targets', '/radar/cube', '/imu', '/gps', '/lidar/points', '/lidar/depth', '/lidar/reflect'],
      topics: [
        { display: 'Camera JPEG', value: '/camera/jpeg' },
        { display: 'Camera H264', value: '/camera/h264' },
        { display: '2D Bounding Box', value: '/model/boxes2d' },
        { display: 'Segmentation Mask', value: '/model/mask' },
        { display: 'Radar PCD', value: '/radar/targets' },
        { display: 'Radar Cube', value: '/radar/cube' },
        { display: 'Pose', value: '/imu' },
        { display: 'Location', value: '/gps' },
        { display: 'LiDAR PCD', value: '/lidar/points' },
        { display: 'LiDAR Depth Map', value: '/lidar/depth' },
        { display: 'LiDAR Reflect Map', value: '/lidar/reflect' },
      ],
      useFPS: false,
      fps: 1,
      loadingDatasets: false,
      isStartingSnapshot: false,
    };
  },
  computed: {
    projectList() {
      return this.$store.state.projects.projectList;
    },
  },
  watch: {
    dataset: {
      deep: true,
      handler() {
        if (this.dataset && this.dataset.annotation_sets && this.dataset.annotation_sets.length > 0) {
          this.annotationSet = this.dataset.annotation_sets[0];
        }
      },
    },
  },

  methods: {
    async selectedProjectChange(p) {
      if (p) {
        this.datasets = await this.getDatasets(p);
        if (this.datasets && this.datasets.length > 0) {
          this.dataset = this.datasets[0];
        }
      }
    },
    async getDatasets(project) {
      const params = {
        project_id: project.id,
        get_annotation_sets: true,
      };
      this.loadingDatasets = true;
      const resp = await this.dataConnect.getDatasetList(params)
        .catch((error) => {
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Failed to retrieve datasets: ${error}`,
            type: 'error',
            position: 'top',
          });
        });
      if (!resp || resp.error || !resp.result) {
        // TODO: handle error
        if (resp.error) console.error(resp.error);
        $toast.open({
          queue: true,
          duration: 5000,
          message: `Failed to retrieve datasets: ${resp.error}`,
          type: 'error',
          position: 'top',
        });
        this.loadingDatasets = false;
        return [];
      }
      this.loadingDatasets = false;
      return resp.result;
    },
    async showModal() {
      if (this.inputProject) {
        this.project = this.projectList.find((e) => e.id === this.inputProject.id);
        await this.selectedProjectChange(this.project);
      }
      this.$nextTick(() => {
        if (this.datasets && this.datasets.length > 0 && this.inputDataset) {
          this.dataset = this.datasets.find((e) => e.id === this.inputDataset.id);
        }
      });
      this.$refs.snapshotsModal.showModal();
    },
    closeModal() {
      this.project = null;
      this.datasets = null;
      this.dataset = null;
      this.annotationSet = null;
      this.new_snapshot = '';
      this.createNewName = '';
      this.createNewDescription = '';
      this.depthGen = false;
      this.agtgPipeline = false;
      this.useFPS = false;
      this.fps = 1;
      this.mcapTopics = false;
      this.selectedTopics = ['/camera/jpeg', '/camera/h264', '/model/boxes2d', '/model/mask', '/radar/targets', '/radar/cube', '/imu', '/gps', '/lidar/points', '/lidar/depth', '/lidar/reflect'];
      this.$refs.snapshotsModal.closeModal();
    },
    async addSnapshot() {
      this.message = '';
      if (!this.project) {
        this.message = "Missing project";
        return;
      }
      if (!this.dataset) {
        this.message = "Missing dataset";
        return;
      }
      if (!this.new_snapshot || this.new_snapshot === '') {
        this.message = "Missing description";
        return;
      }
      const params = {
        dataset_id: this.dataset.id,
        description: this.new_snapshot,
      };
      if (this.annotationSet) {
        params.annotation_set_id = this.annotationSet.id;
      }

      this.isStartingSnapshot = true;

      await this.dataConnect.createNewSnapshot(params).then((data) => {
        if (data && data.result) {
          this.getTasks();
          if (!this.isGettingTasks) {
            this.resumeGetTasks();
          }
          this.isStartingSnapshot = false;
          this.closeModal();
          this.$emit('add-snapshot');
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Creating snapshot from '${data.result.dataset_name}' in progress`,
            type: 'success',
            position: 'top',
            // all of other options may go here
          });
        } else {
          this.isStartingSnapshot = false;
          $toast.open({
            queue: true,
            duration: 5000,
            message: data.error.message,
            type: 'error',
            position: 'top',
          });
        }
      }).catch((e) => {
        this.isStartingSnapshot = false;
        console.log(e);
      });
    },
    async restoreSnapshot() {
      this.message = '';
      if (!this.project) {
        this.message = "Missing project";
        return;
      }

      this.isStartingSnapshot = true;

      await this.dataConnect.restoreSnapshot({
        project_id: this.project.id,
        snapshot_id: this.snapshot.id,
        dataset_name: this.createNewName,
        dataset_description: this.createNewDescription,
        depth_gen: this.depthGen,
        agtg_pipeline: this.agtgPipeline,
        fps: this.fps,
        enabled_topics: this.mcapTopics ? this.selectedTopic : [],
        label_names: ['person'],
      }).then((data) => {
        if (data && data.result) {
          this.getTasks();
          if (!this.isGettingTasks) {
            this.resumeGetTasks();
          }
          this.isStartingSnapshot = false;
          this.closeModal();
          $toast.open({
            queue: true,
            duration: 5000,
            message: `Restoring snapshot to dataset '${data.result.dataset_name}' in progress`,
            type: 'success',
            position: 'top',
          });
        } else {
          this.isStartingSnapshot = false;
          $toast.open({
            queue: true,
            duration: 5000,
            message: data.error.message,
            type: 'error',
            position: 'top',
          });
        }
      }).catch((e) => {
        this.isStartingSnapshot = false;
        console.log(e);
      });
    },
  },
};

</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  @include themify() {
      color: themed('body-text-color');
    }
}

.settings {
  padding: 0.75rem 3rem;
  overflow-y:auto;
}

@media (min-width: $breakpoint-sm) {
  .settings {
    min-width: 420px;
  }
}

.description-body {
  height: 100px;
  min-height: 100px;
}

.footer {
  display: flex;
  flex-direction: row;
  padding: 0.75rem 3rem;
  justify-content: flex-end;

  button + button {
    margin-left: 10px;
  }
}

.snapshot-desc {
  color: black !important;
  font-size: 1rem;
}

.result {
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  font-size: 1rem;
  font-weight:600;
  padding: 10px;
  align-items: center;
  justify-content: center;
}

.error {
  @include themify() {
    background: rgba(182, 94, 94, 0.5) ;
    color: themed('color-error')
  }
}

.checkbox-label {
  margin-left: 10px;
  font-size: 14px;
  font-weight: 600;
}

.topics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 220px);
  width: 100%;
  gap: 5px;
  padding: 5px;
  max-height: 500px;
  overflow-y: auto;
}

.help-icon {
  margin: 0 5px;
  color: var(--color-primary);
}

.help-icon:focus {
  outline: none;
}

.dataset-select {
  width: 100%;
  display: flex;
  flex-direction: row
}

</style>
